import React from 'react';
import { Button, Modal } from 'antd';
import PopupView from '../Policies/PopupView';
import { policyAction } from '@src/store/policies/schedule/utils';

function InfoModal({ visible, setVisible, rowData }) {
  const onCancel = () => {
    setVisible(false);
  };

  const policyView = () => {
    return (
      <div>
        {rowData.runSummary && rowData.runSummary.map((c, idx) => <div key={idx}>{c}</div>)}
      </div>
    );
  };

  const reorderView = () => {
    const {
      state = '',
      reorder: { order = '[]' },
    } = rowData;
    const parsedOrder = JSON.parse(order);
    if (state === 'error') {
      const runLog = JSON.parse(rowData.runLog);
      return runLog?.message || 'Error Details not available';
    }
    return parsedOrder.length ? <PopupView order={parsedOrder} /> : 'Order info not available';
  };
  const scheduleType = rowData.type || policyAction.activate;

  return (
    <Modal
      open={visible}
      title="Changelog"
      onCancel={onCancel}
      footer={[
        <Button key="Close" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      {scheduleType === policyAction.activate ? policyView() : reorderView()}
    </Modal>
  );
}

export default InfoModal;
